import { PercentageOutlined } from "@ant-design/icons";
import { useEffect, useState } from "react";
import DataTable from "../../../../Components/DataTable/DataTable";
import { connect } from "react-redux";
import * as actions from "../../../../store/actions/action";
import { dataFetchError } from "../../../../Util/Messages";
import api from "../../../../api/api";
import { getLabel } from "../../../../Util/EpollParser";
import { DatePicker, Input } from "antd";


const DiscountCode = ({ LoadingSetter, ClearLoading, loading }) => {
  const [data, setData] = useState([]);
  const columns = [
    {
      title: "کد",
      dataIndex: "code",
      searchable: true,
    },
    {
      title: "مقدار تخفیف",
      dataIndex: "amount",
      align: "center",
      searchable: true,

      sorter: (a, b) => {
        const aLength = Array.isArray(a.notes) ? a.notes.length : 0;
        const bLength = Array.isArray(b.notes) ? b.notes.length : 0;
        return aLength > bLength;
      },
      renderFormItem: (_, { isEditable, record }) => {
        if (isEditable) {
          return (
            <Input type="number" />
          );
        }
      },
    },
    {
      title: "تعداد کل",
      dataIndex: "total_count",
      defaultSortOrder: "descend",
      sorter: (a, b) => {
        const A = isNaN(+a.count) ? 0 : +a.count;
        const B = isNaN(+b.count) ? 0 : +b.count;
        return A - B;      },
        renderFormItem: (_, { isEditable, record }) => {
          if (isEditable) {
            return (
              <Input type="number" />
            );
          }
        },
    },
    {
      title: "تعداد باقی مانده",
      dataIndex: "remains",
      defaultSortOrder: "descend",
      sorter: (a, b) => {
        const A = isNaN(+a.count) ? 0 : +a.count;
        const B = isNaN(+b.count) ? 0 : +b.count;
        return A - B;      },
      editable : false,
    },
    {
      title: "تاریخ شروع",
      dataIndex: "startdate",
      defaultSortOrder: "descend",
      sorter: (a, b) => {
        const A = isNaN(+a.count) ? 0 : +a.count;
        const B = isNaN(+b.count) ? 0 : +b.count;
        return A - B;      },
        renderFormItem: (_, { isEditable, record }) => {
          if (isEditable) {
            return (
              <DatePicker />
            );
          }
        },
    },
    {
      title: "تاریخ پایان",
      dataIndex: "enddate",
      defaultSortOrder: "descend",
      sorter: (a, b) => {
        const A = isNaN(+a.count) ? 0 : +a.count;
        const B = isNaN(+b.count) ? 0 : +b.count;
        return A - B;      },
        renderFormItem: (_, { isEditable, record }) => {
          if (isEditable) {
            return (
              <DatePicker />
            );
          }
        },
    },
    {
      title: "پیام به کاربر",
      dataIndex: "user_message",
      align: "center",
      searchable : true,
      renderFormItem: (_, { isEditable, record }) => {
        if (isEditable) {
          return (
            <Input.TextArea />
          );
        }
      },
     
    },
  ];
  const loadData = () => {
    LoadingSetter();
    api
      .get("/question/formdto")
      .then((res) => {
        return res.data;
      })
      .then((questions) => {
        api
          .get("/roadmaps/report/answersnotecount")
          .then((countRes) => {
            api.get("/roadmaps/report/answersnotenotes").then((notesRes) => {
              let countResParsed = {};
              let notesResParsed = {};

              for (const key in countRes.data.answersNoteCountReport) {
                const count =
                  typeof countRes.data.answersNoteCountReport[key] ==
                  "undefined"
                    ? 0
                    : countRes.data.answersNoteCountReport[key];

                let questionId = key;
                if (key.indexOf("-") !== -1) {
                  questionId = key.split("-")[0];
                }

                if (typeof countResParsed[questionId] == "undefined") {
                  countResParsed[questionId] = 0;
                }

                countResParsed[questionId] += count;
              }

              for (const key in notesRes.data.answersNoteNotesReport) {
                const note =
                  typeof notesRes.data.answersNoteNotesReport[key] ==
                  "undefined"
                    ? null
                    : notesRes.data.answersNoteNotesReport[key];

                if (note == null) {
                  continue;
                }

                let questionId = key;
                if (key.indexOf("-") !== -1) {
                  questionId = key.split("-")[0];
                }

                if (typeof notesResParsed[questionId] == "undefined") {
                  notesResParsed[questionId] = [];
                }

                notesResParsed[questionId].push(note);
              }

              const data = [...questions.formDto].map((question) => {
                let count = countResParsed[question.id];
                let notes = notesResParsed[question.id];

                return {
                  title: getLabel(question),
                  count,
                  notes,
                  id: question.id,
                };
              });
              setData(data);
              ClearLoading();
            });
          })

          .catch((err) => {
            ClearLoading();
            dataFetchError();
          });
      })
      .catch((err) => {
        console.log(err);
        ClearLoading();
        dataFetchError();
      });
  };

  useEffect(() => {
    loadData();
    // loadFlagsData();
  }, []);
  return (
    <>
      <DataTable
        tableKey="discount-code"
        dataSource={data}
        setDataSource={setData}
        columns={columns}
        permissionsPrefix="flags"
        reload={loadData}
        editable
        keepPageOnSave
        header={{
          title: "کدهای تخفیف",
          avatar: { icon: <PercentageOutlined />, size: "large" },
        }}
      />
    </>
  );
};
const mapStateToProps = (state) => {
  return {
    loading: state.loading,
    error: state.error,
    permissions: state.userData ? state.userData.permissions : null,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    ClearError: () => dispatch(actions.ClearError()),
    ClearLoading: () => dispatch(actions.ClearLoading()),
    LoadingSetter: () => dispatch(actions.LoadingSetter()),
    ErrorSetter: () => dispatch(actions.ErrorSetter()),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(DiscountCode);
